import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';

import * as color from '../../../constants/colors';
import * as authConstants from '../../../constants/auth';

import * as authActionCreators from '../../../actions/auth';
import * as loginActionCreators from '../../../actions/login';
import * as userActionCreators from '../../../actions/user';
let allActionCreators = Object.assign({}, authActionCreators, loginActionCreators, userActionCreators);

import {saveLogin, saveUser} from '../../../utils/auth';
import {emailValidation, passwordValidation} from '../../../utils/itemValidation';

import TextField from 'material-ui/TextField';


class Login extends React.Component {

  static propTypes = {
    location: PropTypes.object
  };

  static contextTypes = {
    store: PropTypes.any,
    router: PropTypes.object.isRequired
  };

  constructor(props) {
    super(props);
    this.state = {
      requestPending: false,
      serverError: null,
      username: '',
      password: '',
      email: '',
      errors: {
        username: null,
        password: null,
        email: null,
      },
      viewForgot: false,
    };
  }

  changeUsername(evt) {
    this.setState({ username: evt.target.value });
  }

  validateUsername() {
    setTimeout(() => {
      this.setState({ errors: Object.assign({}, this.state.errors, {username: emailValidation(this.state.username)}) });
    }, 100);
  }

  changeEmail(evt) {
    this.setState({ email: evt.target.value });
  }

  validateEmail() {
    setTimeout(() => {
      this.setState({ errors: Object.assign({}, this.state.errors, {email: emailValidation(this.state.email)}) });
    }, 100);
  }

  changePassword(evt) {
    this.setState({
      password: evt.target.value
    })
  }

  validatePassword() {
    this.setState({ errors: Object.assign({}, this.state.errors, {password: passwordValidation(this.state.password)}) });
  }

  validateAll() {
    let usernameError = emailValidation(this.state.username);
    let passwordError = passwordValidation(this.state.password);

    this.setState({
      errors: Object.assign({}, this.state.errors, {
        username: usernameError,
        password: passwordError,
      })
    });
    if(
      usernameError === null &&
      passwordError === null
    ) {
      return true;
    } else {
      return false;
    }
  }

  handleSubmit(evt) {
    evt.preventDefault();

    if(this.validateAll()) {

      this.setState({
        requestPending: true,
        serverError: null,
      });
      this.props.callLogin(evt.target[0].value, evt.target[1].value)
      .then((respData) => {
        
        this.setState({
          requestPending: false,
          serverError: null,
        });

        saveLogin(respData.auth.auth_token);
        saveUser(respData.auth.user);
        this.props.userSetUser(respData.auth.user);
        this.props.authSave(respData.auth.auth_token, Date.now() + authConstants.LOGOUT_TIME);
        this.context.router.push('/');
      })
      .catch((errorData) => {
        let errorMessage = errorData.message ? errorData.message : 'Cannot connect to server';
        this.setState({
          requestPending: false,
          serverError: errorMessage,
        });
      });
    }
  }

  validateEmail() {
    let emailError = emailValidation(this.state.email);

    this.setState({
      errors: Object.assign({}, this.state.errors, {
        email: emailError,
      })
    });
    if(emailError === null) {
      return true;
    } else {
      return false;
    }
  }

  handleForgot(evt) {
    evt.preventDefault();

    if(this.validateEmail()) {

      this.setState({
        requestPending: true,
        serverError: null,
        forgotSuccess: false,
      });
      this.props.callForgotPassword(evt.target[0].value)
      .then((respData) => {
        
        this.setState({
          requestPending: false,
          serverError: null,
          forgotSuccess: true,
        });

      })
      .catch((errorData) => {
        let errorMessage = errorData.message ? errorData.message : 'Cannot connect to server';
        this.setState({
          requestPending: false,
          serverError: errorMessage,
          forgotSuccess: false,
        });
      });
    }
  }

  toggleForgot() {
    this.setState({ viewForgot: !this.state.viewForgot });
  }

  render() {
    return <div className='Login'>
      {this.state.viewForgot ?
        <div className='externalWrapper'>
          <div className='loginLogo'>
            <img src='/img/dd-logo.png' />
          </div>
          <div className='externalTitle'>Diamond Transfer Management</div>
          {this.state.serverError ? 
            <div className='externalError'>{this.state.serverError}</div> :
            null
          }
          {this.state.forgotSuccess ?
            <div className='externalError' style={{color: '#33723A'}}>Please check your email for reset link.</div> :
            null
          }
          <form 
            className='ResponsiveForm'
            onSubmit={::this.handleForgot}>
            <div className='formRow'>
              <div className='inputWrapper'>
                <TextField
                  value={this.state.email} 
                  onChange={::this.changeEmail} 
                  onBlur={::this.validateEmail}
                  errorText={this.state.errors.username} 
                  hintText='Enter email address'
                  floatingLabelText='Email address'
                  type='email'
                  floatingLabelFocusStyle={{color: color.DD_PURPLE}}
                  underlineFocusStyle={{borderColor: color.DD_PURPLE}}
                  fullWidth={true} 
                  required />
              </div>
            </div>
            <div className='forgotRow' onClick={::this.toggleForgot}>Back to Login</div>
            <div className='formRow'>
              <div className='inputWrapper'>
                <button
                  className={'loginSubmit actionButton'}
                  disabled={this.state.requestPending}
                  type='submit'>
                  Reset Password
                </button>
              </div>
            </div>
          </form>
        </div> :
        <div className='externalWrapper'>
          <div className='loginLogo'>
            <img src='/img/dd-logo.png' />
          </div>
          <div className='externalTitle'>Diamond Transfer Management</div>
          {this.state.serverError ? 
            <div className='externalError'>{this.state.serverError}</div> :
            null
          }
          <form 
            className='ResponsiveForm'
            onSubmit={::this.handleSubmit}>
            <div className='formRow'>
              <div className='inputWrapper'>
                <TextField
                  value={this.state.username} 
                  onChange={::this.changeUsername} 
                  onBlur={::this.validateUsername}
                  errorText={this.state.errors.username} 
                  hintText='Enter email address'
                  floatingLabelText='Email address'
                  type='email'
                  floatingLabelFocusStyle={{color: color.DD_PURPLE}}
                  underlineFocusStyle={{borderColor: color.DD_PURPLE}}
                  fullWidth={true} 
                  required />
              </div>
            </div>
            <div className='formRow'>
              <div className='inputWrapper'>
                <TextField
                  value={this.state.password}
                  onChange={::this.changePassword} 
                  onBlur={::this.validatePassword}
                  errorText={this.state.errors.password}
                  hintText='*********'
                  floatingLabelText='Password'
                  type='password' 
                  floatingLabelFocusStyle={{color: color.DD_PURPLE}}
                  underlineFocusStyle={{borderColor: color.DD_PURPLE}}
                  fullWidth={true} 
                  required />
              </div>
            </div>
            <div className='forgotRow' onClick={::this.toggleForgot}>Forgot Password?</div>
            <div className='formRow'>
              <div className='inputWrapper'>
                <button
                  className={'loginSubmit actionButton'}
                  disabled={this.state.requestPending}
                  type='submit'>
                  Login
                </button>
              </div>
            </div>
          </form>
        </div>
      }
        
    </div>;
  }
}
export default Login;

function mapStateToProps(state) {
  return {
    auth: state.auth,
    business: state.business,
    manager: state.manager
  };
}

export const LoginContainer = connect(
  mapStateToProps,
  allActionCreators
)(Login);